/**
 * The colours of the @react-pdf/renderer documents (the lice reports).
 *
 * react-pdf lays the PDF out without a DOM, so it cannot resolve `var()` or read the theme's
 * computed styles. The values are kept here as plain colours, and this is the only place the
 * PDF documents take a colour from. PDFs are always light whatever the theme on screen, since
 * clients print them; these are what the reports have always printed apart from the header
 * label.
 */
export interface PdfPalette {
    /** The paper. */
    readonly page: string;
    /** Headings, dates and table cells. */
    readonly text: string;
    /** Brand green: the client name, its rule and the table header fill. */
    readonly accent: string;
    /** Text on the accent fill: navy, as on the portal's green buttons. */
    readonly onAccent: string;
    /** Table and cell borders. */
    readonly border: string;
    /** Pen counts below the sampling threshold. */
    readonly warning: string;
    /** The standing logo, as a path under public/. */
    readonly logo: string;
}

export const PDF_PALETTE: PdfPalette = {
    page: 'white',
    // react-pdf's default ink, stated so every colour comes from here.
    text: '#000000',
    accent: '#5bb784',
    // --color-on-status-fill. White on the brand green is 2.46:1; navy is 7.09:1.
    onAccent: '#14192d',
    border: '#ccc',
    warning: 'orange',
    logo: '/logoStanding.png',
};
